import { memo, useCallback, useContext } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import styles from './exclusiveToggleButtonGroup.module.scss';
import { ExclusiveToggleButtonContext } from '../../contexts';

export const ExclusiveToggleButton = memo(({ value, children, className }) => {
  const { selectedValue, setSelectedValue } = useContext(ExclusiveToggleButtonContext);
  const selected = selectedValue === value;

  const handleClick = useCallback(() => setSelectedValue(value), [setSelectedValue, value]);

  return (
    <button
      className={classnames(styles.toggleButton, className, selected && styles.selected)}
      onClick={handleClick}
      role="radio"
      aria-checked={Boolean(selected)}
      type="button"
    >
      {children}
    </button>
  );
});

ExclusiveToggleButton.propTypes = {
  value: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

ExclusiveToggleButton.defaultProps = {
  className: undefined,
};
